const PageStartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.644"
      height="12.246"
      viewBox="0 0 11.644 12.246"
      className="stroke-current"
    >
      <g id="Group_9485" data-name="Group 9485" transform="translate(1 0.744)">
        <path
          id="Path_12208"
          data-name="Path 12208"
          d="M2538.754-16715.273l-6.475,5.826,6.475,4.877"
          transform="translate(-2528.779 16715.273)"
          fill="none"
          strokeWidth={2}
        />
        <line
          id="Line_227"
          data-name="Line 227"
          y1={11}
          transform="translate(0 0.168)"
          fill="none"
          strokeWidth={2}
        />
      </g>
    </svg>
  )
}

export default PageStartIcon
